import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-slide-gallery',
  templateUrl: './slide-gallery.component.html',
  styleUrls: ['./slide-gallery.component.css']
})
export class SlideGalleryComponent implements OnInit {

  constructor() { }

  images: any[];

  ngOnInit() {
    //this.images = [];
    //this.images.push({source: 'assets/images/slide/enviro.jpg', alt: 'Description for Image 1', title: 'Title 1'});
  }

}



// WEBPACK FOOTER //
// /Users/dev-man/Kgwetlwo-app/src/app/widget/slide-gallery/slide-gallery.component.ts